import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BoothOrder from './booth-order';
import HallLayout from './hall-layout';
import BoothSelectionDialog from './booth-selection-dialog';

/** @class HallBooths
  * A component providing the ability to place booths
  * into an expo hall.
  */
export default class HallBooths extends Component {
  /** @constructor
    * Creates a new instance of HallBooths
    */
  constructor(props) {
    super(props);
    this.processBooths = this.processBooths.bind(this);
    this.state = {
      showBoothSelectionDialog: false,
      boothList: this.processBooths(props.booths)
    }
  }
  /** @method componentWillReceiveProps
    * Processes new incoming booths to
    * update the booth list.
    */
  componentWillReceiveProps(newProps) {
    this.setState({
      boothList: this.processBooths(newProps.booths)
    });
  }
  /** @method processBooths
    * Converts a booth map into an ordered array.
    */
  processBooths(booths) {
    var boothList = []
    for(var key in booths) {
      var booth = booths[key];
      booth.id = key;
      boothList.push(booth);
    }
    return boothList.sort((a,b) => b.order - a.order);
  }
  toggleBoothSelectionDialog() {
    this.setState({showBoothSelectionDialog: !this.state.showBoothSelectionDialog});
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <div className="hall-booth-panel">
        <div className="sidebar">
          <BoothSelectionDialog
            hallID={this.props.hallID}
            name={this.props.name}
            booths={this.props.booths}
            boothList={this.state.boothList}
            boothURL={this.props.boothURL}
            hallURL={this.props.hallURL}
            show={this.state.showBoothSelectionDialog}
            onExit={()=>this.toggleBoothSelectionDialog()}
            />
          <button className="big-button caution-color" onClick={()=>this.toggleBoothSelectionDialog()}>
            Add or Remove Booths
          </button>
          <BoothOrder boothList={this.state.boothList}
            dataURL={this.props.hallURL + '/booths'}
            width={this.props.width}
            height={this.props.height}/>
        </div>
        <HallLayout
          boothList={this.state.boothList}
          dataURL={this.props.hallURL + '/booths'}
          stage={this.props.stage}/>
      </div>
    )
  }
}

HallBooths.propTypes = {
  boothURL: PropTypes.string.isRequired,
  hallURL: PropTypes.string.isRequired,
  booths: PropTypes.object.isRequired,
  stage: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/hall-editor/hall-booths.js